module.exports = __webpack_public_path__ + "media/svg/pn-a59daf46.svg";